import { SubmissionError } from "redux-form";
import * as Constants from "./constants";
import fetch, { fetchM } from "../../utils/fetch";

import { push, goBack } from "react-router-redux";
import { idObj, identity, contains } from "../../utils";
import { convert, addressToSend } from "../Cro/converts";
import { togglePanel, setLoading, setApiError } from "../../actions/appActions";
import { isEmpty, get, isEqual, isArray } from "lodash";
import { CZECH_REPUBLIC_ID } from "./constants";
import { constructQuery } from "../../components/Grid/dataActions";
import {encodeBase64, decodeBase64, isOfficial} from "./CroUtils";
import { buildDocx } from "../../utils/htmlToDocx";

export const getRealtyType = async (type, dispatch) => {
  const activeFilter = { field: "active", operation: "EQ", value: "true" };
  const queryFilter = { field: "type.id", operation: "EQ", value: type };
  const constructedQuery = constructQuery({
    filters: [activeFilter, queryFilter],
    sort: "name",
    order: "ASC",
    pageSize: 10,
    page: 0,
  });

  const response = await fetch("/api/ciselniky/nemovite-veci", dispatch, {
    params: constructedQuery,
  });
  return await response.json();
};

export const getFunctionaryNoticeTypes = async (dispatch) => {
  const response = await fetch("/api/ciselniky/vyzva-funkcionari", dispatch);
  return await response.json();
};

export const getAssignees = async (dispatch) => {
  const response = await fetch("/api/ciselniky/vyrizuje", dispatch);
  return await response.json();
};

export const getForwardingReasons = async (dispatch) => {
  const response = await fetch("/api/ciselniky/k-podstoupeni", dispatch);
  return await response.json();
};

export const getAuditChanges = async (startUrl, auditRowId, dispatch) => {
  const response = await fetch(`${startUrl}/api/audit-history/${auditRowId}/changes`, dispatch);
  return await response.json();
};

export const getAuditActions = async (startUrl, dispatch) => {
  const response = await fetch(`${startUrl}/api/audit-history/actions`, dispatch);
  return await response.json();
};

export const getAuditHelpPlacements = async (startUrl, dispatch) => {
  const response = await fetch(`${startUrl}/api/audit-history/help-placements`, dispatch);
  return await response.json();
};

export const saveAuditNote = async (startUrl, payload, dispatch) => {
  const response = await fetch(`${startUrl}/api/audit-history/note`, dispatch, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json" }),
    body: JSON.stringify(payload),
  });
  return await response.json();
};

export const getActiveDictOptions = async (url, dispatch) => {
  const constructedQuery = constructQuery({
    filters: [{ field: "active", operation: "EQ", value: "true" }],
    sort: "name",
    order: "ASC",
    pageSize: 1000,
    page: 0,
  });
  const response = await fetch(url, dispatch, { params: constructedQuery });
  const data = await response.json();
  return isArray(data) ? data : data.items || [];
};

export const ztotoznitAction = async (person, dispatch) => {
  const response = await fetch("/spravce/api/zadosti/ztotoznit", dispatch, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json" }),
    body: JSON.stringify(person),
  });
  return await response.json();
};

export const generateLogin = async (url, dispatch, data) => {
  dispatch(setLoading(true, "Generování jména a hesla..."));
  const response = await fetch(url, dispatch, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json" }),
    body: JSON.stringify(data),
  });

  const r = await response.json();
  dispatch(setLoading());
  return r;
};

export const changePassword = async (data, dispatch, url) => {
  dispatch(setLoading(true, "Probíhá změna hesla..."));
  const response = await fetchM(url, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json" }),
    params: { new: data.new, old: data.old },
  });
  if (!response.ok) {
    if (response.status === 403) {
      dispatch(setLoading());
      throw new SubmissionError({ _error: "Špatné původní heslo" });
    }
    dispatch(setLoading());
    throw new SubmissionError({ _error: "Nepodařilo se zpracovat požadavek" });
  }
  dispatch(setLoading());
};
export const canChangePswdOvm = async () => {
  const response = await fetchM("/podpurny-organ/api/profil/muze-menit-heslo");
  return await response.json();
};

export const withRedirect =
  (fn, url) =>
  (...args) =>
  async (dispatch) => {
    await fn(...args)(dispatch);
    dispatch(push(url));
  };

export const withRedirectBack =
  (fn) =>
  (...args) =>
  async (dispatch) => {
    await fn(...args)(dispatch);
    dispatch(goBack());
  };

export const getMe = async (dispatch) => {
  const response = await fetch("/funkcionar/api/profil/ja", dispatch);
  return await response.json();
};

export const getOfficial = async (id, dispatch) => {
  const response = await fetch(
    `/administrator/api/funkcionari/${id}`,
    dispatch,
  );
  return await response.json();
};

export const getFile = (id) => (window.open(`/api/files/${id}`, "_blank"));

export const postFile = async (
  file,
  url,
  dispatch,
  loadingText = "Nahrávání souborů...",
) => {
  dispatch(setLoading(true, loadingText));
  const data = new FormData();
  data.append("file", file);

  let response;

  try {
    response = await fetch(url, dispatch, {
      method: "POST",
      body: data,
    });
  } catch (e) {
    dispatch(setLoading());
    return null;
  }

  try {
    const responseData = await response.json();
    dispatch(setLoading());
    return responseData;
  } catch (e) {
    dispatch(setLoading());
    return null;
  }
};

const postFn = async (
  data,
  url,
  type,
  dispatch,
  transform = identity,
  text = "Úspěšně odesláno",
) => {
  dispatch(setLoading(true, "Ukládání dat..."));
  try {
    const idData = idObj(transform(data));
    await fetch(url(idData.id), dispatch, {
      method: "POST",
      headers: new Headers({ "Content-Type": "application/json" }),
    });
    dispatch(togglePanel(text));
  } finally {
    dispatch(setLoading());
  }
};

const putFn = async (
  data,
  url,
  type,
  dispatch,
  transform = identity,
  text = "Úspěšně odesláno",
) => {
  dispatch(setLoading(true, "Ukládání dat..."));
  try {
    const idData = idObj(transform(data));
    const response = await fetch(url(idData.id), dispatch, {
      method: "PUT",
      headers: new Headers({ "Content-Type": "application/json" }),
      body: JSON.stringify(idData),
    });
    const responseData = await response.json();
    dispatch({
      type: type,
      payload: {
        data: responseData,
      },
    });
    dispatch(togglePanel(text));
  } finally {
    dispatch(setLoading());
  }
};

const postSimpleFn = async (
  data,
  url,
  dispatch,
  text = null,
  loadingText = "Ukládání dat...",
  transform = identity,
) => {
  dispatch(setLoading(true, loadingText));
  try {
    const response = await fetch(url, dispatch, {
      method: "POST",
      headers: new Headers({ "Content-Type": "application/json" }),
      body: JSON.stringify(transform(data)),
    });
    if (text !== null) {
      dispatch(togglePanel(text));
    }

    return response;
  } finally {
    dispatch(setLoading());
  }
};

const postOneFieldFormFn = async (data, url, dispatch) =>
  await fetch(url, dispatch, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json" }),
    body: data,
  });

const putSimpleFn = async (
  data,
  url,
  dispatch,
  text = null,
  loadingText = "Ukládání dat...",
  transform = identity,
) => {
  dispatch(setLoading(true, loadingText));
  try {
    await fetch(url, dispatch, {
      method: "PUT",
      headers: new Headers({ "Content-Type": "application/json" }),
      body: JSON.stringify(transform(data)),
    });
    if (text !== null) {
      dispatch(togglePanel(text));
    }
  } finally {
    dispatch(setLoading());
  }
};

export const updateInternalUserPhone = (id, phone) => async (dispatch) =>
  await putSimpleFn(
    { phone },
    `/spravce/api/spravci/${id}/phone`,
    dispatch,
    "Telefon aktualizován",
  );

export const updateAdministratorPhone = (id, phone) => async (dispatch) =>
  await putSimpleFn(
    { phone },
    `/spravce/api/administratori/${id}/phone`,
    dispatch,
    "Telefon aktualizován",
  );

export const getForwardingOrpOptions = async (startUrl, officialId, dispatch) => {
  const response = await fetch(
    `${startUrl}/api/forwarding/orps?officialId=${encodeURIComponent(officialId)}`,
    dispatch,
  );
  return await response.json();
};

export const getForwardingPayload = async (startUrl, officialId, req, dispatch) => {
  const response = await fetch(`${startUrl}/api/forwarding/payload/${officialId}`, dispatch, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json" }),
    body: JSON.stringify(req),
  });
  return await response.json();
};

export const getAdministrativeAuthorityOptions = async (startUrl, dispatch) => {
  const response = await fetch(
    `/api/ciselniky/spravni-organ?sort=name&order=ASC&pageSize=1000`,
    dispatch,
  );
  return await response.json();
}

const extractFilenameFromContentDisposition = (header, fallback) => {
  if (!header) return fallback;
  const utf8Match = header.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (utf8Match) return decodeURIComponent(utf8Match[1]);
  const plainMatch = header.match(/filename\s*=\s*"?([^";]+)"?/i);
  if (plainMatch) return plainMatch[1].trim();
  return fallback;
};

export const forwardOfficial = (startUrl, officialId, body) => async (dispatch) => {
  dispatch(setLoading(true, "Generuji dokument..."));
  try {
    const response = await fetch(
      `${startUrl}/api/forwarding/document/${officialId}`,
      dispatch,
      {
        method: "POST",
        headers: new Headers({ "Content-Type": "application/json" }),
        body: JSON.stringify(body),
      },
    );
    const blob = await response.blob();
    const filename = extractFilenameFromContentDisposition(
      response.headers.get("Content-Disposition"),
      `postoupeni-${officialId}.docx`,
    );
    downloadBlob(blob, filename, dispatch);

    dispatch(togglePanel("Dokument vygenerován"));
  } finally {
    dispatch(setLoading());
  }
};

const noReturnFn = async (
  method,
  data,
  dispatch,
  url,
  transform = identity,
  omitIdFromBody = false,
) => {
  dispatch(setLoading(true, "Ukládání dat..."));
  try {
    const idData = idObj(transform(data));
    const { id: _id, ...bodyWithoutId } = idData;
    await fetch(url(idData.id), dispatch, {
      method: method,
      headers: new Headers({ "Content-Type": "application/json" }),
      body: JSON.stringify(omitIdFromBody ? bodyWithoutId : idData),
    });
  } finally {
    dispatch(setLoading());
  }
};

const deleteFn = async (url, dispatch) => {
  await fetch(url, dispatch, {
    method: "DELETE",
    headers: new Headers({ "Content-Type": "application/json" }),
  });
  dispatch(togglePanel("Úspěšně smazáno"));
};

const deleteDataFn = async (data, url, dispatch, transform = identity) => {
  await fetch(url, dispatch, {
    method: "DELETE",
    headers: new Headers({ "Content-Type": "application/json" }),
    body: JSON.stringify(transform(data)),
  });
  dispatch(togglePanel("Úspěšně smazáno"));
};

const transformOfficial = (data) =>
  convert(data, {
    birthAddress: addressToSend,
    deliveryAddress: addressToSend,
    permanentAddress: addressToSend,
  });
export const saveOfficial = (url) => (data) => async (dispatch) => {
  if (isEmpty(data.workingPositions)) {
    throw new SubmissionError({ _error: "Není zadána žádná funkce." });
  } else {
    for (let i = 0; i < data.workingPositions.length; i++) {
      if (
        data.workingPositions[i].created &&
        data.workingPositions[i].created.length === 16
      ) {
        data.workingPositions[i].created =
          data.workingPositions[i].created + ":00.000Z";
      }
    }
  }
  if (
    data.locked &&
    data.isMy === false &&
    isEqual(get(data, "originalWPs", 0).sort(), data.workingPositions.sort())
  ) {
    throw new SubmissionError({ _error: "Nebyla přidána žádná funkce." });
  }

  let parseData = data;
  await putFn(
    parseData,
    (id) => `${url}/api/funkcionari/${id}`,
    Constants.OFFICIAL,
    dispatch,
    transformOfficial,
    "Úspěšně uloženo",
  );
};

export const unarchiveOfficial = (url) => (data) => async (dispatch) => {
  let parseData = data;
  await postFn(
    parseData,
    (id) => `${url}/api/archivace/funkcionar/odarchivovat/${id}`,
    Constants.OFFICIAL,
    dispatch,
    transformOfficial,
    "Úspěšně uloženo",
  );
};

export const getArchivedCsv =
  (data, auth, entity) =>
  async (dispatch, transform = identity) => {
    dispatch(setLoading(true, "Probíhá export do CSV. Prosím čekejte..."));
    const response = await fetch(
      `${auth.startUrl}/api/archivace/${entity}/export`,
      dispatch,
      {
        method: "POST",
        headers: new Headers({ "Content-Type": "application/json" }),
        body: JSON.stringify(transform(data)),
      },
    );
    const fileRef = await response.json();
    dispatch(setLoading());
    getFile(fileRef.id);
  };

export const deleteOfficial = (url) => (id) => async (dispatch) =>
  await deleteFn(`${url}/api/funkcionari/${id}`, dispatch);
export const deleteOfficials = (data, auth) => async (dispatch) =>
  await deleteDataFn(data, `${auth.startUrl}/api/funkcionari/mazani`, dispatch);
export const finallyDeleteOfficials =
  (data, auth, entity) => async (dispatch) => {
    const en =
      entity === "funkcionari"
        ? "funkcionářů"
        : entity === "zadosti"
          ? "žádostí"
          : entity === "podnety" && "podnětu";
    const confirmed = window.confirm(
      `Hodláte trvale vymazat celkem ${data.length} ${en}. Tato akce je nevratná. Souhlasíte s vymazáním?`,
    );
    if (confirmed === true) {
      await deleteDataFn(
        data,
        `${auth.startUrl}/api/archivace/${entity}/smazat`,
        dispatch,
      );
    }
  };
export const unarchiveOfficials = (data, auth, entity) => async (dispatch) => {
  await postSimpleFn(
    data,
    `${auth.startUrl}/api/archivace/${entity}/odarchivovat`,
    dispatch,
    null,
    "Odarchivování...",
  );
};
export const appealOfficial =
  ({ officialId, content, noticeTypeId }) =>
  async (dispatch) => {
    dispatch(setLoading(true, "Odesílání výzvy..."));
    await postOneFieldFormFn(
      encodeBase64(content),
      `/spravce/api/funkcionari/${officialId}/vyzva-bez-sablony/${noticeTypeId}`,
      dispatch,
    );
    dispatch(togglePanel("Úspěšně odesláno"));
    dispatch(setLoading());
  };

export const appealOfficials =
  ({ officialsIds, content, subject }) =>
  async (dispatch) => {
    await postSimpleFn(
      { officialIds: officialsIds, content: encodeBase64(content), subject, appealType: "INCOMPLETE" },
      `/spravce/api/funkcionari/vyzva`,
      dispatch,
      "Úspěšně odesláno",
      "Odesílání " + (officialsIds.length === 1 ? "výzvy..." : "výzev..."),
    );
  };

export const changeProfile = async (data, dispatch, url) => {
  dispatch(setLoading(true, "Odesílání dat..."));
  await fetch(url, dispatch, {
    method: "PUT",
    headers: new Headers({ "Content-Type": "application/json" }),
    body: JSON.stringify(convert(data, { address: addressToSend })),
  });
  dispatch(setLoading());
};

export const getOfficialAddress = async (startUrl, id, dispatch) => {
  dispatch(setLoading(true, "Načítání adresy trvalého bydliště..."));
  let response;

  try {
    response = await fetch(
      `${startUrl}/api/funkcionari/${id}/adresa`,
      dispatch,
    );
  } catch (e) {
    dispatch(setApiError(null));
    dispatch(setLoading());
    return null;
  }

  try {
    const responseData = await response.json();
    dispatch(setLoading());
    return responseData;
  } catch (e) {
    dispatch(setLoading());
    return null;
  }
};

export const saveOvm = (url) => (data) => async (dispatch) =>
  await putFn(
    data,
    (id) => `${url}/api/podpurne-organy/${id}`,
    Constants.OVM,
    dispatch,
  );

export const deleteOvm = (id, note) => async (dispatch) => {
  var url = `/administrator/api/podpurne-organy/${id}/delete`;
  if (note) {
    url += "?note=" + encodeURIComponent(note);
  }
  await postFn({ id: id }, () => url, null, dispatch, undefined, "Úspěšně smazáno");
};

export const generateHandoverProtocolOfficialWorkingPosition = async (officialId, wpId, type, dispatch) => {
  dispatch(setLoading(true, "Generování předávacího protokolu..."));
  try {
    const match = (officialId || "").match(/[0-9a-fA-F-]{36}/);
    const oId = match ? match[0] : officialId;
    const response = await fetch(
        `/podpurny-organ/api/funkcionari/${oId}/funkce/${wpId}/predavaci-protokol/${type}`,
        dispatch,
    );
    const html = await response.text();

    await buildDocx({ html, filename: `Předávací protokol.docx`, margins: { top: 500 } });
  } finally {
    dispatch(setLoading());
  }
}

export const saveFinancialinstitutions = (url) => (data) => async (dispatch) =>
  await putFn(
    data,
    (id) => `${url}/api/financni-instituce/${id}`,
    Constants.OVM,
    dispatch,
  );
export const deleteFinancialinstitutions = (url, id) => async (dispatch) =>
  await deleteFn(`${url}/api/financni-instituce/${id}`, dispatch);

export const saveLegitimate = (url) => (data) => async (dispatch) =>
  await putFn(
    data,
    (id) => `${url}/api/opravnene-organy/${id}`,
    Constants.LEGITIMATE,
    dispatch,
    undefined,
    "Úspěšně uloženo",
  );
export const deleteLegitimate = (id, note) => async (dispatch) => {
  var url = `/administrator/api/opravnene-organy/${id}/delete`;
  if (note) {
    url += "?note=" + encodeURIComponent(note);
  }
  await postFn({ id: id }, () => url, null, dispatch, undefined, "Úspěšně smazáno");
};

export const assignOfficialToLegitimate = async (
  legitimateId,
  officialId,
  dispatch,
) => {
  await fetch(
    `/spravce/api/opravnene-organy/${legitimateId}/funkcionari/${officialId}`,
    dispatch,
    {
      method: "PUT",
      headers: new Headers({ "Content-Type": "application/json" }),
      body: "",
    },
  );
  dispatch(togglePanel("Přístup byl přidán"));
};

export const unassignOfficialFromLegitimate = async (
  legitimateId,
  officialId,
  dispatch,
) => {
  await fetch(
    `/spravce/api/opravnene-organy/${legitimateId}/funkcionari/${officialId}`,
    dispatch,
    {
      method: "DELETE",
      headers: new Headers({ "Content-Type": "application/json" }),
    },
  );
  dispatch(togglePanel("Přístup byl odebrán"));
};

const transformRequest = (data) =>
  convert(data, {
    person: {
      address: addressToSend,
      deliveryAddress: addressToSend,
    },
    legalPerson: { address: addressToSend },
  });
export const saveRequest = (data) => async (dispatch) => {
  if (isEmpty(data.officials)) {
    throw new SubmissionError({ _error: "Nebyl vybrán žádný funkcionář." });
  }
  await putFn(
    data,
    (id) => `/spravce/api/zadosti/${id}`,
    Constants.REQUEST,
    dispatch,
    transformRequest,
  );
};
export const newRequest = (data) => async (dispatch) => {
  if (isEmpty(data.officials)) {
    throw new SubmissionError({ _error: "Nebyl vybrán žádný funkcionář." });
  }
  await noReturnFn(
    "POST",
    data,
    dispatch,
    (id) => `/verejnost/api/zadosti`,
    transformRequest,
    true,
  );
};
export const newRequestInternal = (data) => async (dispatch) => {
  if (isEmpty(data.officials)) {
    throw new SubmissionError({ _error: "Nebyl vybrán žádný funkcionář." });
  }
  await noReturnFn(
    "PUT",
    data,
    dispatch,
    (id) => `/spravce/api/zadosti/${id}`,
    transformRequest,
  );
};
export const acceptRequest =
  ({ id }) =>
  async (dispatch) =>
    await fetch(`/spravce/api/zadosti/${id}/schvalit`, dispatch, {
      method: "POST",
    });
export const rejectRequest =
  ({ id, reason }) =>
  async (dispatch) =>
    await postOneFieldFormFn(
      reason,
      `/spravce/api/zadosti/${id}/zamitnout`,
      dispatch,
    );

const transformInitiative = (data) =>
  convert(data, {
    person: {
      address: addressToSend,
      deliveryAddress: addressToSend,
    },
    legalPerson: { address: addressToSend },
  });
export const saveInitiative = (data) => async (dispatch) =>
  await putFn(
    data,
    (id) => `/spravce/api/podnety/${id}`,
    Constants.INITIATIVE,
    dispatch,
    transformInitiative,
  );
export const newInitiative = (data) => async (dispatch) =>
  await noReturnFn(
    "POST",
    data,
    dispatch,
    () => `/verejnost/api/podnety`,
    transformInitiative,
    true,
  );
export const acceptInitiative =
  ({ id }) =>
  async (dispatch) =>
    await fetch(`/spravce/api/podnety/${id}/prijmout`, dispatch, {
      method: "POST",
    });
export const replyInitiative =
  ({ id }) =>
  async (dispatch) =>
    await fetch(`/spravce/api/podnety/${id}/vyrozumet`, dispatch, {
      method: "POST",
    });
export const rejectInitiative =
  ({ id, reason }) =>
  async (dispatch) =>
    await postOneFieldFormFn(
      reason,
      `/spravce/api/podnety/${id}/zamitnout`,
      dispatch,
    );

export const sendInitiative =
  ({ id, organization, forwardingComment, forwardingReasons }) =>
  async (dispatch) =>
    await fetch(`/spravce/api/podnety/${id}/postoupit`, dispatch, {
      method: "POST",
      headers: new Headers({ "Content-Type": "application/json" }),
      body: JSON.stringify({
        organization,
        forwardingComment,
        forwardingReasons: forwardingReasons || [],
      }),
    });

export const saveDictionaryItem = (url) => (data) => async (dispatch) =>
  await putFn(
    data,
    (id) => `${url}/${id}`,
    Constants.DICTIONARY_ITEM,
    dispatch,
  );
export const deleteDictionaryItem = (url) => (id) => async (dispatch) =>
  await deleteFn(`${url}/${id}`, dispatch);

const transformStatement = (data) =>
  convert(data, {
    official: { birthAddress: addressToSend, deliveryAddress: addressToSend },
    statementOfficial: {
      birthAddress: addressToSend,
      deliveryAddress: addressToSend,
    },
    naturalPersonBusinesses: { address: addressToSend },
    legalBusinessAssociates: { legalPerson: { address: addressToSend } },
    organizationMember: { legalPerson: { address: addressToSend } },
    otherContracts: { address: addressToSend },
    corporationShares: { address: addressToSend },
    corporationSharesBefore: { address: addressToSend },
    incomes: { legalPerson: { address: addressToSend } },
    liabilities: { legalPerson: { address: addressToSend } },
    media: { legalPerson: { address: addressToSend } },
    realties: addressToSend,
    realtiesBefore: addressToSend,
  });

export const canPublicSeeStatement = async (id, dispatch) => {
  const response = await fetch(
    `/verejnost/api/funkcionari/schvaleno/${id}`,
    dispatch,
  );
  return await response.json();
};
export const newStatement =
  (startUrl) =>
  (data, text = "Uspěšně uloženo") =>
  async (dispatch) =>
    await putFn(
      data,
      (id) =>
        startUrl.includes("funkcionar")
          ? `${startUrl}/api/oznameni/${id}`
          : `${startUrl}/api/funkcionari/${data.official.id}/oznameni`,
      Constants.STATEMENT,
      dispatch,
      transformStatement,
      text,
    );
export const createStatement =
  (startUrl) =>
  (data, text = "Uspěšně uloženo") =>
  async (dispatch) => {
    dispatch(setLoading(true, "Ukládání dat..."));
    try {
      const { id, ...dataWithoutId } = transformStatement(data);
      const response = await fetch(`${startUrl}/api/oznameni`, dispatch, {
        method: "POST",
        headers: new Headers({ "Content-Type": "application/json" }),
        body: JSON.stringify(dataWithoutId),
      });
      const responseData = await response.json();
      dispatch({
        type: Constants.STATEMENT,
        payload: { data: responseData },
      });
      dispatch(togglePanel(text));
    } finally {
      dispatch(setLoading());
    }
  };

export const sendStatement =
  ({ id }) =>
    async (dispatch) =>
      await postSimpleFn(
        "",
        `/funkcionar/api/oznameni/${id}/odeslat`,
        dispatch,
        "Úspěšně odesláno",
      );

export const incompleteStatement =
  (startUrl) =>
  ({ id, statement_id }) =>
  async (dispatch) =>
    await postSimpleFn(
      "",
      `${startUrl}/api/funkcionari/${id}/oznameni/${statement_id}/neuplne`,
      dispatch,
    );

export const getStatementVersion = async (startUrl, officialId, statementId, versionId, dispatch) => {
  dispatch(setLoading(true, "Načítání dat..."));

  try {
    const response = await fetch(
        `${startUrl}/api/funkcionari/${officialId}/oznameni/${statementId}/verze/${versionId}`,
        {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
        },
    );

    return await response.json();
  } finally {
    dispatch(setLoading());
  }
};

export const getStatementPdf =
  (startUrl, visibility = "") =>
  (data) =>
  async (dispatch) => {
    dispatch(setLoading(true, "Probíhá export do PDF. Prosím čekejte..."));
    const response = await fetch(
      `${startUrl}/api/${contains(startUrl, "spravce") || contains(startUrl, "admin") ? "funkcionari/" : ""}oznameni/export/pdf${visibility ? `/${visibility}` : ""}`,
      dispatch,
      {
        method: "PUT",
        headers: new Headers({ "Content-Type": "application/json" }),
        body: JSON.stringify(transformStatement(data)),
      },
    );
    const fileRef = await response.json();
    dispatch(setLoading());
    getFile(fileRef.id);
  };

export const downloadStatementDigitalActCertificate = async (auth, statementId, dispatch) => {
  dispatch(setLoading(true, "Stahování osvědčení o digitálním úkonu..."));
  try {
    const url = isOfficial(auth) ?
        `/funkcionar/api/oznameni/${statementId}/digitalni-ukon-osvedceni` :
        `${auth.startUrl}/api/funkcionari/oznameni/${statementId}/digitalni-ukon-osvedceni`;

    const response = await fetch(url, dispatch);
    const blob = await response.blob();

    if (blob.size === 0) {
      dispatch(togglePanel("Osvědčení o digitálním úkonu k tomuto oznámení ještě neexistuje."));
      dispatch(setLoading());
      return;
    }

    downloadBlob(blob, "Osvědčení o digitálním úkonu.pdf");

    dispatch(setLoading());
  } catch (error) {
    dispatch(setLoading());
    console.error("Failed to download digital act certificate:", error);
  }
};

export const deleteStatements = (data) => async (dispatch) =>
  await deleteDataFn(data, `/administrator/api/funkcionari/oznameni`, dispatch);

export const getPersonByIco = async (ico, dispatch) => {
  const response = await fetch("/funkcionar/api/iszr/ros/hledat", dispatch, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json" }),
    params: { ico },
  });
  const persons = await response.json();

  if (persons.length === 1) {
    return persons[0];
  }

  return null;
};

export const saveHelps = (data) => async (dispatch) => {
  dispatch(setLoading(true, "Ukládání nápověd..."));
  await fetch("/administrator/api/napovedy/saveall", dispatch, {
    method: "PUT",
    headers: new Headers({ "Content-Type": "application/json" }),
    body: JSON.stringify(
      data.array.filter((d) => {
        return !d.subhead;
      }),
    ),
  });
  dispatch(setLoading());
  dispatch(togglePanel("Úspěšně uloženo"));
};

export const getCzechRepublic = async (dispatch) => {
  const response = await fetch(
    `/api/ciselniky/staty/${CZECH_REPUBLIC_ID}`,
    dispatch,
  );
  return await response.json();
};

export const getOrp = async (dispatch, municipalityId) => {
  if (municipalityId === "") return "";
  try {
    const response = await fetch(
      `/api/ciselniky/mesta/${municipalityId}`,
      dispatch,
    );
    const address = await response.json();
    return get(address, "orp", "");
  } catch (err) {
    return "";
  }
};

export const getAresData = async (ico) => {
  try {
    const response = await fetchM(`/funkcionar/api/ares/${ico}`);
    if (response.status === 404) {
      return { error: "notFound" };
    }
    if (!response.ok) {
      return { error: "unavailable" };
    }
    return await response.json();
  } catch (e) {
    return { error: "unavailable" };
  }
};

export const bulkAssign =
  ({ url, itemIds, assigneeId }) =>
  async (dispatch) => {
    dispatch(setLoading(true, "Přidělování zpracovatele..."));
    try {
      await fetch(url, dispatch, {
        method: "PUT",
        headers: new Headers({ "Content-Type": "application/json" }),
        body: JSON.stringify({
          itemIds,
          assignee: assigneeId ? { id: assigneeId } : null,
        }),
      });
      dispatch(togglePanel("Úspěšně přiděleno"));
    } finally {
      dispatch(setLoading());
    }
  };

export const saveBanner = (data) => async (dispatch) =>
  await putFn(
    data,
    (id) => `/administrator/api/info-banner/${id}`,
    "INFO_BANNER",
    dispatch,
  );

export const deleteBanner = (id) => async (dispatch) =>
  await deleteFn(`/administrator/api/info-banner/${id}`, dispatch);

export const activateBanner = (id) => async (dispatch) => {
  await fetch(`/administrator/api/info-banner/${id}/activate`, dispatch, {
    method: "POST",
  });
  dispatch(togglePanel("Banner aktivován"));
};

export const deactivateBanner = (id) => async (dispatch) => {
  await fetch(`/administrator/api/info-banner/${id}/deactivate`, dispatch, {
    method: "POST",
  });
  dispatch(togglePanel("Banner deaktivován"));
};

export const saveBannerTemplate = (data) => async (dispatch) =>
  await putFn(
    data,
    (id) => `/administrator/api/info-banner-template/${id}`,
    "INFO_BANNER_TEMPLATE",
    dispatch,
  );

export const deleteBannerTemplate = (id) => async (dispatch) =>
  await deleteFn(`/administrator/api/info-banner-template/${id}`, dispatch);

export const setDefaultTemplate = (id) => async (dispatch) => {
  await fetch(
    `/administrator/api/info-banner-template/${id}/default`,
    dispatch,
    { method: "POST" },
  );
  dispatch(togglePanel("Výchozí šablona nastavena"));
};

export const fetchBannerTemplates = async (dispatch) => {
  const response = await fetch(
    "/administrator/api/info-banner-template",
    dispatch,
  );
  const result = await response.json();
  return result.items || result || [];
};

export const fetchVisibleBanners = (role) => async (dispatch) => {
  const url = role ? `/api/info-banner?role=${role}` : "/api/info-banner";
  const response = await fetch(url, dispatch);
  return await response.json();
};

export const fetchActiveBanners = async (dispatch) => {
  const response = await fetch(
    "/administrator/api/info-banner/active",
    dispatch,
  );
  return await response.json();
};

export const saveTemplate = (data) => async (dispatch) => {
  dispatch(setLoading(true, "Ukládání..."));
  if (data.id) {
    await putFn(
      data,
      (id) => `/spravce/api/sablony/${data.id}`,
      Constants.EMAIL_TEMPLATE,
      dispatch,
      () => data,
      "Úspěšně uloženo",
    );
  } else {
    await postSimpleFn(
      data,
      `/spravce/api/sablony`,
      dispatch,
      "Úspěšně uloženo",
      "Ukládání...",
    );
  }
};

export const deleteTemplate = (id) => async (dispatch) => {
  await deleteFn(`/spravce/api/sablony/${id}`, dispatch);
};

export const toggleActivateTemplate =
  (id, publish) => async (dispatch) => {
    await postSimpleFn(
      null,
      `/spravce/api/sablony/${id}/${publish ? "publish" : "unpublish"}`,
      dispatch,
      publish ? "Šablona aktivována" : "Šablona deaktivována",
      "Ukládání...",
    );
  };

export const getBaselineTemplate = (type) => async (dispatch) => {
  const response = await fetch(`/spravce/api/sablony/baseline?type=${encodeURIComponent(type)}`, dispatch);
  if (response.status === 404) {
    return null;
  }
  const data = await response.json();
  return decodeBase64(data.content);
};

export const deleteStatement = (id) => async (dispatch) => {
  dispatch(setLoading(true, "Mazání oznámení..."));
  await fetch(`/funkcionar/api/oznameni/${id}`, dispatch, {
    method: "DELETE",
  });
  dispatch(setLoading());
};

export const saveWorkingPosition = (startUrl, officialId, wp) => async (dispatch) => {
  dispatch(setLoading(true, "Ukládání funkce..."));
  const response = await fetch(
      `${startUrl}/api/funkcionari/${officialId}/funkce/${wp.id}`,
      dispatch,
      {
        method: "PUT",
        headers: new Headers({ "Content-Type": "application/json" }),
        body: JSON.stringify(wp),
      }
  );
  const result = await response.json();
  dispatch(setLoading());
  return result;
};

export const deleteWorkingPosition = (startUrl, officialId, wpIds) => async (dispatch) => {
  dispatch(setLoading(true, "Mazání funkcí..."));
  try {
    await fetch(
        `${startUrl}/api/funkcionari/${officialId}/funkce`,
        dispatch,
        {
          method: "DELETE",
          headers: new Headers({"Content-Type": "application/json"}),
          body: JSON.stringify(wpIds),
        }
    );
    dispatch(togglePanel("Úspěšně smazáno"));
  } finally {
    dispatch(setLoading());
  }
}

export const getNotificationDuration = () => async (dispatch) => {
  try {
    const response = await fetch(
        "/api/nastaveni/by-key/notification_duration_seconds",
        dispatch,
        { method: "GET" }
    );
    const setting = await response.json();
    return parseInt(setting.value, 10) || 30;
  } catch (e) {
    return 30; // fallback
  }
};

export const updateNotificationDuration = (value) => async (dispatch) => {
  dispatch(setLoading(true, "Ukládání..."));
  try {
    await fetch(
        "/administrator/api/nastaveni/by-key/notification_duration_seconds",
        dispatch,
        {
          method: "PUT",
          headers: new Headers({ "Content-Type": "text/plain" }),
          body: String(value),
        }
    );
  } finally {
    dispatch(setLoading());
  }
};

export const createStatementInspectionResult = (startUrl, officialId, statementId, inspectionResult, forwardedTo, note) => async (dispatch) => {
  dispatch(setLoading(true, `Ukládání kontroly...`));
  try {
    await fetch(
        `${startUrl}/api/funkcionari/${officialId}/oznameni/${statementId}/kontroly`,
        dispatch,
        {
          method: "POST",
          headers: new Headers({"Content-Type": "application/json"}),
          body: JSON.stringify({
            result: inspectionResult,
            forwardedTo,
            note
          }),
        }
    );
    dispatch(togglePanel("Úspěšně uloženo"));
  } finally {
    dispatch(setLoading());
  }
};

export const createWorkingPositionInspectionResult = (startUrl, officialId, officialWorkingPositionId, inspectionType, inspectionResult, periodYear, forwardedTo, note) => async (dispatch) => {
  dispatch(setLoading(true, `Ukládání kontroly...`));
  try {
    await fetch(
        `${startUrl}/api/funkcionari/${officialId}/funkce/${officialWorkingPositionId}/kontroly`,
        dispatch,
        {
          method: "POST",
          headers: new Headers({"Content-Type": "application/json"}),
          body: JSON.stringify({
            type: inspectionType,
            result: inspectionResult,
            periodYear,
            forwardedTo,
            note
          }),
        }
    );
    dispatch(togglePanel("Úspěšně uloženo"));
  } finally {
    dispatch(setLoading());
  }
};

export const updateInspectionResult = (authUrl, officialId, inspectionId) => (data) => async (dispatch) => {
  dispatch(setLoading(true, "Ukládání kontroly..."));
  try {
    await fetch(
        `${authUrl}/api/funkcionari/${officialId}/kontroly/${inspectionId}`,
        dispatch,
        {
          method: "PUT",
          headers: new Headers({"Content-Type": "application/json"}),
          body: JSON.stringify({...data}),
        }
    );
    dispatch(togglePanel("Úspěšně uloženo"));
  } finally {
    dispatch(setLoading());
  }
}

export const deleteInspectionResult = (authUrl, officialId, inspectionId) => () => async (dispatch) => {
  dispatch(setLoading(true, "Mazání kontroly..."));
  try {
    await fetch(
        `${authUrl}/api/funkcionari/${officialId}/kontroly/${inspectionId}`,
        dispatch,
        {
          method: "DELETE",
          headers: new Headers({ "Content-Type": "application/json" }),
        }
    );
    dispatch(togglePanel("Úspěšně smazáno"));
  } finally {
    dispatch(setLoading());
  }
}

export const markOfficialsAsInspected = (authUrl, officialIds) => async (dispatch) => {
  dispatch(setLoading(true, "Zápis kontrol..."));
  try {
    await fetch(`${authUrl}/api/funkcionari/kontroly/zkontrolovano`, dispatch, {
      method: "PUT",
      headers: new Headers({"Content-Type": "application/json"}),
      body: JSON.stringify(officialIds),
    });
    dispatch(togglePanel("Úspěšně zapsáno"));
  } finally {
    dispatch(setLoading());
  }
};

export const validateRealtyOwnership = async (ownerName, ownerSurname, birthDate, lv, ku, parcelNumber, dispatch) => {
  try {
    const response = await fetch(`/funkcionar/api/cuzk/validate-realty`, dispatch, {
      method: "POST",
      headers: new Headers({"Content-Type": "application/json"}),
      body: JSON.stringify({
        ownerName,
        ownerSurname,
        birthDate,
        lv,
        ku,
        parcelNumber
      })
    });
    return await response.json();
  } catch (e) {
    return null;
  }
}

export const downloadFileRef = async (fileRef, downloadFileName, dispatch) => {
  const fileContent = await fetch(
      `/api/files/${fileRef.id}`,
      dispatch);
  const blob = await fileContent.blob();
  if (blob.size > 0) {
    downloadBlob(blob, downloadFileName);
  }
}

const downloadBlob = (blob, fileName) => {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

export const getServicesMonitoring = async (dispatch) => {
  try {
    const response = await fetch(`/api/monitoring`, dispatch, {
      method: "GET",
      headers: new Headers({"Content-Type": "application/json"}),
    });
    return await response.json();
  } catch (e) {
    return null;
  }
}